import _ from 'lodash';
import * as React from 'react';

import SaveLayout from 'components/ModalWindows/Shared/SaveLayout';
import { DocumentClassification, DocumentClassificationMedcomms, DocumentSubtype, DocumentType, isVeevaMedcomms } from 'const';
import { AUDIENCE_TYPE, CHANNEL_TYPE, CONTENT_TYPE } from 'const/MedComms/Tags';
import * as Models from 'models';
import { TagEntitiesMap, TagEntity } from 'models/entities/Tag';
import { intlGet } from 'utils/intlGet';
import { SaveReusableLayoutProps } from './models';

const SaveReusableLayout: React.FunctionComponent<SaveReusableLayoutProps> = ({
  documentTypes,
  saveReusableLayout,
  rootDocument,
  hideModal,
  modalWindowId,
  options,
  reusableLayoutsDocuments,
  reusableLayoutsNames,
  layoutPreview,
  generateLayoutPreview,
  updateAppState,
  cancelLayoutPreviewGeneration,
}) => {
  const layout = options.get('layout');
  const layoutId = layout.get('id');
  const layoutDocument = reusableLayoutsDocuments.get(layout.get('documentId'));
  const subtype = layoutDocument && layoutDocument.get('subtype');
  const defaultClassification = isVeevaMedcomms() ? DocumentClassificationMedcomms.HEADER : DocumentClassification.UNCLASSIFIED;
  const classification = subtype === DocumentSubtype.CONTENT_UNIT ? layoutDocument.get('classification') : defaultClassification;

  const getDefaultLayoutName = (count = 1): string => {
    const subtype = rootDocument.get('subtype');
    const sectionDisplayName = options.get('sectionDisplayName');
    const defaultLayoutName = `${subtype}_${sectionDisplayName ? `${sectionDisplayName}_` : ''}${count}`;

    if (reusableLayoutsNames.includes(defaultLayoutName)) {
      return getDefaultLayoutName(count + 1);
    }

    return defaultLayoutName;
  };

  const saveLayout = (
    name: string,
    classification: DocumentClassification,
    audienceType: string[],
    channelType: string[],
    contentType: string[],
  ): void => {
    saveReusableLayout({
      classification,
      layoutId,
      name,
      previewUrl: layoutPreview.get('s3Url'),
      subtype: DocumentSubtype.CONTENT_UNIT,
      audienceType,
      channelType,
      contentType,
    });
  };
  const generatePreview = (): void => { generateLayoutPreview([layoutId]); };

  const getSortedClassifications = (classificationsMap: Models.DocumentClassificationsMap): string[] => {
    return classificationsMap
      ? _(classificationsMap.toJS() as Models.DocumentClassifications).sortBy('index').map('label').value()
      : [];
  };

  const documentType = documentTypes.get(DocumentType.COMPONENT);
  const documentSubtypesMap = documentType && documentType.get('subtypes');
  const documentSubtypeMap = documentSubtypesMap && documentSubtypesMap.get(DocumentSubtype.CONTENT_UNIT);
  const documentClassificationsMap = documentSubtypeMap && documentSubtypeMap.get('classifications');
  const documentClassifications = getSortedClassifications(documentClassificationsMap);

  const audienceTypeData = (documentSubtypeMap?.getIn(['properties', AUDIENCE_TYPE]) as TagEntitiesMap)?.toJS() as TagEntity;
  const channelTypeData = (documentSubtypeMap?.getIn(['properties', CHANNEL_TYPE]) as TagEntitiesMap)?.toJS() as TagEntity;
  const contentTypeData = (documentSubtypeMap?.getIn(['properties', CONTENT_TYPE]) as TagEntitiesMap)?.toJS() as TagEntity;

  return (
    <SaveLayout
      cancelPreviewGeneration={cancelLayoutPreviewGeneration}
      documentClassifications={documentClassifications}
      initialClassification={classification}
      audienceTypeData={audienceTypeData}
      channelTypeData={channelTypeData}
      contentTypeData={contentTypeData}
      initialLayoutName={getDefaultLayoutName()}
      generatePreview={generatePreview}
      hideModal={hideModal}
      layoutPreview={layoutPreview}
      modalWindowId={modalWindowId}
      saveLayout={saveLayout}
      title={intlGet('SaveReusableLayout', 'Title')}
      updateAppState={updateAppState}
    />
  );
};

export default SaveReusableLayout;
